import {
  Component,
  ContentChildren,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
} from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';

@Component({
  selector: 'dynamic-field',
  templateUrl: './dynamic-field.component.html',
  styleUrls: ['./dynamic-field.component.scss'],
  standalone: false,
})
export class DynamicFieldComponent implements OnChanges {
  public constructor(@Inject(ENV_CONFIG) private _config: env.EnvData) {}

  @Input() public props: app.models.DynamicProps;
  @Input() public canBeEmpty: boolean = false;

  @ContentChildren('dynamic') public inputs: QueryList<ElementRef<any>>;

  public controlFound: boolean = false;
  public hasErrors: boolean = false;
  public errorMessage: string;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.props.currentValue == null && changes.props.firstChange) return;

    setTimeout(() => {
      if (this.props == null) {
        this.logError('Props are not defined');
        return;
      }

      if (this.inputs != null && this.inputs.length > 0) {
        if (this.inputs.length >= 2) {
          this.logError('More than 1 input elements found');
          return;
        }

        this.controlFound = true;

        if (this.props.readonly) {
          let input = this.inputs.find(x => !!x);
          input.nativeElement.disabled = this.props.readonly;
        }
      }

      if (!this.controlFound && !this.canBeEmpty) {
        this.logError("No control found. If intended, specify by providing [canBeEmpty]='true'");
      }
    });
  }

  private logError(message: string) {
    this.hasErrors = true;
    this.errorMessage = `[DEBUG] ${message}`;
    if (this._config.LOGGING_ENABLED) {
      console.log(`[DYNAMIC PROPERTY ERROR] ${message}`);
    }
  }
}
